export enum VehicleStatusOption {
  Default = 0,
  VehiclesWithGroups = 1,
  VehiclesWithoutGroups = 2,
}

export interface VehicleFilterOptions {
  status?: VehicleStatusOption;
  vehicleGroupName?: string;
}
